import React from 'react';
import { useTranslation } from 'react-i18next';

import LoadThemeComponent from '../../base/LoadThemeComponent';

import usePageLanguagePrefix from '../../hooks/UsePageLanguagePrefix';
import { addTrailingSlashToUrl } from '../common/Route';

import NotificationItem from './Notification';
import { DatabaseNotification } from './types';

function NotificationsList({
    notifications,
    onMarkAllAsRead,
}: Readonly<{
    notifications: DatabaseNotification[];
    onMarkAllAsRead?: () => void;
}>) {
    const { t } = useTranslation();

    const pageLanguagePrefix = usePageLanguagePrefix();
    let listUrl = '/account/notifications';

    if (pageLanguagePrefix) {
        listUrl = `/${pageLanguagePrefix}${listUrl}`;
    }
    listUrl = addTrailingSlashToUrl(listUrl);

    const baseView = () => (
        <div id="notifications-list" className="dropdown-menu dropdown-menu-right menu-notification">
            <div className="rectangle-black d-flex align-items-center">
                <div className="container d-md-none d-flex justify-content-end">
                    <i className="fas fa-times" />
                </div>
            </div>
            {notifications?.map((notification) => (
                <NotificationItem key={notification.id} notification={notification} />
            ))}
            {!notifications?.length ? <a className="dropdown-item">{t('notifications.emptyList')}</a> : null}
            <a className="dropdown-item" href={listUrl}>
                {t('notifications.showAll')}
            </a>
        </div>
    );

    const defaultView = () => (
        <div id="notifications-list" className="dropdown-menu dropdown-menu-right menu-notification">
            {notifications?.length > 0 ? (
                <div className="notifications-header position-relative d-flex justify-content-between">
                    <span>Notifications ({notifications?.length})</span>
                    <div onClick={onMarkAllAsRead}>
                        <i className="fas fa-check" />
                        <span className="mark-as-read"> Mark as read </span>
                    </div>
                </div>
            ) : (
                <div className="notifications-header border-0">
                    <span>You have no new notifications</span>
                </div>
            )}
            {notifications?.map((notification) => (
                <NotificationItem key={notification.id} notification={notification} />
            ))}
        </div>
    );

    return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
}

export default NotificationsList;
